import type { AppRouter } from "@stringiverse/trpc-server";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { ZObject } from "zapier-platform-core";

export type FetchEsque = (
	input: Request | URL | string,
	init?: RequestInit,
) => Promise<Response>;

export const createClient = (
	_fetch: FetchEsque = fetch,
	baseUrl = "/api/trpc",
	_zapier: ZObject | null = null,
) =>
	createTRPCClient<AppRouter>({
		links: [
			httpBatchLink({
				url: baseUrl,
				fetch: _fetch,
			}),
		],
	});

// Also export the client creator for custom configuration
export default createClient;
